/**
 * KAN-866 — a device-local "I just left for the Stripe billing portal" marker, so the suspended screen can tell a
 * return from the portal (no URL param) from a plain visit. Per user + tenant, `{ startedAt }` only (no PII), 15 min TTL.
 * Every storage call is best-effort: a blocked storage never throws.
 */
export const PORTAL_RETURN_PREFIX = 'cvx-portal-return-v1:';
export const PORTAL_RETURN_TTL_MS = 15 * 60 * 1000;

export const portalReturnKey = (userId, tenantId) => `${PORTAL_RETURN_PREFIX}${tenantId || 'tenant'}:${userId || 'anon'}`;

export function markPortalStarted(userId, tenantId, storage, nowMs = Date.now()) {
  if (!userId) return;
  try { (storage || window.localStorage).setItem(portalReturnKey(userId, tenantId), JSON.stringify({ startedAt: nowMs })); } catch { /* best-effort */ }
}

/** True when a fresh marker existed; the marker is always cleared. */
export function takePortalReturn(userId, tenantId, storage, nowMs = Date.now()) {
  if (!userId) return false;
  let fresh = false;
  try {
    const s = storage || window.localStorage;
    const key = portalReturnKey(userId, tenantId);
    const m = JSON.parse(s.getItem(key) || 'null');
    fresh = Boolean(m) && Number.isFinite(m.startedAt) && nowMs - m.startedAt < PORTAL_RETURN_TTL_MS;
    s.removeItem(key);
  } catch { /* best-effort */ }
  return fresh;
}
